import angular from 'angular';
import '../resources/organization-messages';
import { map, cloneDeep } from 'lodash';

const module = angular.module('whyline.services.organization-messages', [
  'whyline.resources.organization-messages',
]);

let OrganizationMessage;
let ErrorService;
let $timeout;

class OrganizationMessagesService {
  static $inject = ['$timeout', 'OrganizationMessages', 'ErrorService'];

  constructor(injected$timeout, injectedOrganizationMessage, injectedErrorService) {
    $timeout = injected$timeout;
    OrganizationMessage = injectedOrganizationMessage;
    ErrorService = injectedErrorService;
  }

  GetAll(organizationId) {
    return OrganizationMessage.GetCurrent(organizationId);
  }

  GetDefaults() {
    const defaultMessageConfiguration = [
      {
        enabled: true,
        readOnly: false,
        type: 'push',
      },
      {
        enabled: true,
        readOnly: false,
        type: 'sms',
      },
    ];

    return map([
      {
        messages: [
          {
            content: 'You are in the virtual line of {{{placeName}}}. This is your turn: {{{alias}}}. Follow the progress here {{{link}}}',
            language: 'en',
            title: 'Join',
          },
          {
            content: 'Estas en la fila virtual de {{{placeName}}}. Este es tu turno: {{{alias}}}. Seguí el avance aquí {{{link}}}',
            language: 'es',
            title: 'Join',
          },
          {
            content: 'Você está na fila virtual de {{{placeName}}}. Agora é sua vez: {{{alias}}}. Siga o progresso aqui {{{link}}}',
            language: 'pt',
            title: 'Join',
          },
        ],
        slug: 'join_message',
        configuration: [
          {
            enabled: false,
            readOnly: false,
            type: 'push',
          },
          {
            enabled: false,
            readOnly: false,
            type: 'sms',
          },
        ]
      },
      {
        messages: [
          {
            content: 'It\'s your turn in line {{{queueName}}} at {{{placeName}}}.',
            language: 'en',
            title: 'It\'s your turn!',
          },
          {
            content: 'Estás siendo llamado de la fila {{{queueName}}} en {{{placeName}}}.',
            language: 'es',
            title: '¡Es tu turno!',
          },
          {
            content: 'é a sua vez na fila {{{queueName}}} em {{{placeName}}}.',
            language: 'pt',
            title: 'É sua vez!',
          },
        ],
        slug: 'its_your_turn',
      },
      {
        messages: [
          {
            content: '{{{personName}}} you are next in the line {{{queueName}}}',
            language: 'en',
            title: 'You are next!',
          },
          {
            content: '{{{personName}}} sos el próximo en la fila {{{queueName}}}',
            language: 'es',
            title: '¡Sos el próximo!',
          },
          {
            content: '{{{personName}}} você é o seguinte na fila {{{queueName}}}',
            language: 'pt',
            title: 'Você é o seguinte!',
          },
        ],
        slug: 'you_are_next',
      },
      {
        messages: [
          {
            content: '{{{personName}}} you have {{peopleAhead}} {{personOrPeople}} ahead in line, you will be called approximately in {{waitingTime}}',
            language: 'en',
            title: 'Attention!',
          },
          {
            content: '{{{personName}}} tenés {{peopleAhead}} {{personOrPeople}} adelante, serás atendido aproximadamente en {{waitingTime}}',
            language: 'es',
            title: '¡Atención!',
          },
          {
            content: '{{{personName}}} você tem {{peopleAhead}} {{personOrPeople}} em frente',
            language: 'pt',
            title: 'Atenção!',
          },
        ],
        slug: 'people_ahead',
      },
      {
        messages: [
          {
            content: '{{{personName}}} you will be called in less than 20 minutes in {{{queueName}}}',
            language: 'en',
            title: 'Soon',
          },
          {
            content: '{{{personName}}} te atenderemos en menos de 20 minutos en {{{queueName}}}',
            language: 'es',
            title: 'En breve',
          },
          {
            content: '{{{personName}}} você será atendido em menos de 20 minutos em {{{queueName}}}',
            language: 'pt',
            title: 'Em seguida',
          },
        ],
        slug: 'check_in_early',
      },
      {
        messages: [
          {
            content: '{{{personName}}} you will be called in {{waitingTime}}.',
            language: 'en',
            title: 'Take advantage of your time!',
          },
          {
            content: '{{{personName}}} te atenderemos en {{waitingTime}}',
            language: 'es',
            title: '¡Aprovechá tu tiempo!',
          },
          {
            content: '{{{personName}}} você será atendido em {{waitingTime}}',
            language: 'pt',
            title: 'Aproveite melhor o seu tempo!',
          },
        ],
        slug: 'check_in',
      },
      {
        messages: [
          {
            content: 'Hello! Remind that today you have an appointment at {{{placeName}}} for {{{queueName}}}, at {{appointmentTime}}.',
            language: 'en',
            title: 'You have an Appointment',
          },
          {
            content: '¡Hola! Te recordamos que hoy tienes una cita en {{{placeName}}} para {{{queueName}}}, a las {{appointmentTime}}.',
            language: 'es',
            title: 'Tienes una Cita',
          },
          {
            content: 'Olá! Lembramos que hoje você tem um agendamento em {{{placeName}}} para {{{queueName}}}, às {{appointmentTime}}.',
            language: 'pt',
            title: 'Você tem um Agendamento',
          },
        ],
        slug: 'appointment_reminder',
      },
      {
        configuration: [
          {
            enabled: false,
            readOnly: true,
            type: 'push',
          },
          {
            enabled: true,
            readOnly: false,
            type: 'sms',
          },
        ],
        messages: [
          {
            content: 'Hello {{personName}}! To know the waiting time from your mobile phone, download the Whyline App (www.whyline.com)',
            language: 'en',
            title: 'Download Whyline',
          },
          {
            content: '¡Hola {{personName}}! Para conocer el tiempo de espera desde tu telefono, descarga la App Whyline (www.whyline.com)',
            language: 'es',
            title: 'Descarga Whyline',
          },
          {
            content: 'Olá, {{personName}}! Para saber o tempo de espera através do celular, baixe o App da Whyline (www.whyline.com)',
            language: 'pt',
            title: 'Descarrega Whyline',
          },
        ],
        slug: 'download_application',
      },
      {
        configuration: [
          {
            enabled: false,
            readOnly: true,
            type: 'push',
          },
          {
            enabled: false,
            readOnly: false,
            type: 'sms',
          },
        ],
        messages: [
          {
            content: 'It has now been {{delayTime}} {{delayUnit}} since you were alerted, and we have not heard from you. Please, tell us if you are late o you want to cancel the reservation at this link {{{link}}}',
            language: 'en',
            title: 'Call alert',
          },
          {
            content: 'Han pasado {{delayTime}} {{delayUnit}} desde que fue alertado y no hemos tenido noticias suyas. Por favor, díganos si llega tarde o desea cancelar la reserva en este enlace {{{link}}}',
            language: 'es',
            title: 'Alerta de llamado',
          },
          {
            content: 'Já se passaram {{delayTime}} {{delayUnit}} desde que você foi alertado e não tivemos notícias suas. Por favor, diga-nos se você está atrasado ou deseja cancelar a reserva neste link {{{link}}}',
            language: 'pt',
            title: 'Alerta de chamada',
          },
        ],
        slug: 'delay_message',
      },
    ], message => {
      message.configuration = message.configuration || cloneDeep(defaultMessageConfiguration);

      return message;
    });
  }

  GetAllAsPromise(organizationId) {
    return OrganizationMessage.GetAllMessages(organizationId)
      .then(messages => $timeout(() => Promise.resolve(messages || [])))
      .catch(ErrorService.handler);
  }

  GetAllReadAsPromise(organizationId, placeId) {
    return OrganizationMessage.GetAllReadMessages(organizationId, placeId)
      .then(messages => $timeout(() => Promise.resolve(messages || [])))
      .catch(ErrorService.handler);
  }

  UpdateAllMessages(messages, organizationId, forAllPlaces) {
    return OrganizationMessage.UpdateAllMessages(messages, organizationId, forAllPlaces)
      .then(messagesFromServer => $timeout(() => Promise.resolve(messagesFromServer || [])))
      .catch(ErrorService.handler);
  }
}

module.exports = module.service('OrganizationMessagesService', OrganizationMessagesService);
